import { Link } from 'react-router-dom';
import React from 'react';
import { ButtonBase } from '@mui/material';
import Logo from './Logo';

const LogoSection = () => (
    <ButtonBase disableRipple component={Link} to={'/menu'}>
        <Logo />
    </ButtonBase>
);

export default LogoSection;